import React, { useState } from 'react';

import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import { Alert, CircularProgress, Dialog, DialogContent, DialogTitle, IconButton, Menu, MenuItem } from '@mui/material';

import LensSchedulesDialog from '~/pages/LeLens/schedules/LensSchedulesDialog';

import { useGetReportingLeLens } from '~/hooks/apis/reporting/useGetReportingLeLens';
import useCurrentUser from '~/hooks/useCurrentUser';

import type { LensFilterValues, LensPeriod } from '~/types/leLens';

import { nativeLensId } from './nativeLensId';

type Props = {
  pageId: string;
  filters: LensFilterValues;
  filterOptions: Record<string, Array<string>>;
  ready: boolean;
  onDownloadPdf: () => void;
  initialPeriod?: LensPeriod | null;
};

export default function NativeLensActions({
  pageId,
  filters,
  filterOptions,
  ready,
  onDownloadPdf,
  initialPeriod,
}: Props) {
  const [open, setOpen] = useState(false);
  const [anchor, setAnchor] = useState<HTMLElement | null>(null);
  const { user } = useCurrentUser();
  const query = useGetReportingLeLens(open ? nativeLensId(pageId) : undefined);
  return (
    <>
      <IconButton aria-label="Report actions" aria-haspopup="menu" onClick={(event) => setAnchor(event.currentTarget)}>
        <MoreHorizIcon />
      </IconButton>
      <Menu anchorEl={anchor} open={Boolean(anchor)} onClose={() => setAnchor(null)}>
        <MenuItem
          disabled={!ready}
          onClick={() => {
            setAnchor(null);
            onDownloadPdf();
          }}
        >
          Download PDF
        </MenuItem>
        <MenuItem
          disabled={!ready}
          onClick={() => {
            setAnchor(null);
            setOpen(true);
          }}
        >
          Schedule email…
        </MenuItem>
      </Menu>
      {open && query.data ? (
        <LensSchedulesDialog
          open
          onClose={() => setOpen(false)}
          lens={query.data.lens}
          screenValues={filters}
          filterOptions={filterOptions}
          userEmail={user?.email}
          allowPeriodOverride={false}
          initialPeriod={initialPeriod}
        />
      ) : (
        <Dialog open={open} onClose={() => setOpen(false)} fullWidth maxWidth="sm">
          <DialogTitle>Schedule email</DialogTitle>
          <DialogContent>
            {query.isError ? (
              <Alert severity="error">
                {query.error?.message ?? 'The report could not load. Check its Library registration and try again.'}
              </Alert>
            ) : (
              <CircularProgress size={24} aria-label="Loading report schedules" />
            )}
          </DialogContent>
        </Dialog>
      )}
    </>
  );
}
